import { all_routes } from "../../router/all_routes";
import * as func from "./FunctionCalls";

class Utils {
    static getAccessToken() {
        // return window.localStorage.getItem("accessToken");
        const accessToken = localStorage.getItem('accessToken')
        return accessToken;
    }

    static logoutUser() {
        // func.logout();
        localStorage.clear();
        window.location.href = all_routes.athleteLogin;
    }
}

export default Utils;